import React from 'react';
import { Mail } from 'lucide-react';
import { IconBrandLinkedin as Linkedin, IconBrandTwitter as Twitter, IconBrandGithub as Github } from '@tabler/icons-react';
import { Sec, SH } from '../components/Shared';

const ExecutivePage = () => {
  const leadership = [
    [
      { name: 'Md Nur Al Maruf Newaz', role: 'Moderator', type: 'Moderator', bio: '', social: {} },
      { name: 'Kazi Tahmina Munmun', role: 'Co-Moderator', type: 'Moderator', bio: '', social: {} }
    ],
    [
      { name: 'Mohammad Abdul Halim', role: 'Advisor', type: 'Advisor', bio: '', social: {} },
      { name: 'A.R.M. Delowar Hossain', role: 'Advisor', type: 'Advisor', bio: '', social: {} }
    ],
    [
      { name: 'Md. Mahmudul Hasan', role: 'Advisor', type: 'Advisor', bio: '', social: {} },
      { name: 'Samsul Haque', role: 'Advisor', type: 'Advisor', bio: '', social: {} },
      { name: 'Zahid Islam', role: 'Advisor', type: 'Advisor', bio: '', social: {} }
    ]
  ];

  const executive = [
    [
      { name: 'AM.Maruful Haque Raiyan', role: 'President', type: 'Executive', bio: 'Executive Committee 2026', social: {} },
      { name: 'Nusrat Jahan Mohona', role: 'Vice President', type: 'Executive', bio: 'Executive Committee 2026', social: {} }
    ],
    [
      { name: 'Mehetab Hasan', role: 'General Secretary', type: 'Executive', bio: 'Executive Committee 2026', social: {} },
      { name: 'Adnan sami', role: 'Asst. General Secretary', type: 'Executive', bio: 'Executive Committee 2026', social: {} },
      { name: 'MD SHAFI', role: 'Asst. General Secretary', type: 'Executive', bio: 'Executive Committee 2026', social: {} }
    ],
    [
      { name: 'Saran khan', role: 'Treasurer', type: 'Executive', bio: 'Executive Committee 2026', social: {} },
      { name: 'U Ching Thowai Marma', role: 'Asst. Treasurer', type: 'Executive', bio: 'Executive Committee 2026', social: {} }
    ]
  ];

  const renderModeratorCard = (m, i) => {
    const isBlue = i % 2 !== 0;
    const bg = isBlue ? '#E0F2FE' : '#FEF3C7';
    const radius = isBlue ? '8px 48px 8px 48px' : '48px 8px 48px 8px';

    return (
      <div key={`${m.name}-${i}`} className={`au d${(i % 3) + 1}`} style={{
        display: 'flex', flexDirection: 'column', flex: 1, minWidth: 260, maxWidth: 300,
        background: bg, borderRadius: radius, overflow: 'hidden',
        boxShadow: '0 10px 30px rgba(0,0,0,0.02)', transition: 'transform .3s ease', position: 'relative'
      }} onMouseOver={e => e.currentTarget.style.transform = 'translateY(-8px)'} onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}>

        <div style={{ height: 280, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.3)' }}>
          {m.img ? (
            <img src={m.img} alt={m.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            <div style={{ fontSize: 64, fontWeight: 800, color: 'rgba(0,0,0,0.05)' }}>{m.name[0]}</div>
          )}
        </div>

        <div style={{ background: '#1F2937', color: '#fff', padding: '20px 24px', textAlign: 'left', borderTopLeftRadius: isBlue ? 0 : 24, borderTopRightRadius: isBlue ? 24 : 0 }}>
          <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 800, color: '#fff', marginBottom: 4 }}>{m.name}</h3>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,.7)' }}>{m.role}</div>
        </div>
      </div>
    );
  };

  const renderExecutiveCard = (m, i) => (
    <div key={`${m.name}-${i}`} className={`au d${(i % 3) + 1}`} style={{
      display: 'flex', flexDirection: 'column', flex: 1, minWidth: 260, maxWidth: 320,
      textAlign: 'center', transition: 'all .3s ease'
    }} onMouseOver={e => e.currentTarget.style.transform = 'translateY(-4px)'} onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}>
      <div style={{ height: 300, background: '#f4f7f6', overflow: 'hidden', marginBottom: 20 }}>
        {m.img ? <img src={m.img} alt={m.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (
          <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 64, fontWeight: 800, color: 'var(--slate-200)' }}>{m.name[0]}</div>
        )}
      </div>
      <div style={{ padding: '0 16px' }}>
        <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 800, textTransform: 'uppercase', color: 'var(--on-surface)', marginBottom: 4, letterSpacing: '.05em' }}>{m.name}</h3>
        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--primary)', marginBottom: 16 }}>{m.role}</div>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
          {[
            { icon: <Mail size={16} />, link: m.social?.mail },
            { icon: <Linkedin size={16} />, link: m.social?.linkedin },
            { icon: <Github size={16} />, link: m.social?.github },
            { icon: <Twitter size={16} />, link: m.social?.twitter }
          ].filter(s => s.link).map((s, idx) => (
            <a key={idx} href={s.link} style={{ color: 'var(--slate-800)', transition: 'color .2s' }} onMouseOver={e => e.currentTarget.style.color = 'var(--primary)'} onMouseOut={e => e.currentTarget.style.color = 'var(--slate-800)'}>
              {s.icon}
            </a>
          ))}
          {!Object.keys(m.social || {}).length && (
            <div style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
              <a href="https://membership.icditc.club/" style={{ color: 'var(--slate-800)' }}><Mail size={16} /></a>
              <a href="https://membership.icditc.club/" style={{ color: 'var(--slate-800)' }}><Linkedin size={16} /></a>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="af">
      <Sec py={160} bg="var(--grad-hero)">
        <SH eyebrow="Council" title="Technical Board" sub="The core team maintaining our operational matrix and leading technical tracks." center={true} />

        <div style={{ marginBottom: 120 }}>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 28, fontWeight: 700, color: 'var(--on-surface)', marginBottom: 64, textAlign: 'center' }}>Moderator & Advisor</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 64, alignItems: 'center' }}>
            {leadership.map((row, rIdx) => (
              <div key={rIdx} style={{ display: 'flex', gap: 40, justifyContent: 'center', flexWrap: 'wrap', width: '100%' }}>
                {row.map((m, i) => renderModeratorCard(m, i))}
              </div>
            ))}
          </div>
        </div>

        <div style={{ marginBottom: 120 }}>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 28, fontWeight: 700, color: 'var(--on-surface)', marginBottom: 64, textAlign: 'center' }}>Executive Committee</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 32, alignItems: 'center' }}>
            {executive.map((row, rIdx) => (
              <div key={rIdx} style={{ display: 'flex', gap: 24, justifyContent: 'center', flexWrap: 'wrap', width: '100%' }}>
                {row.map((m, i) => renderExecutiveCard(m, i))}
              </div>
            ))}
          </div>
        </div>

        <div>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 28, fontWeight: 700, color: 'var(--on-surface)', marginBottom: 48, textAlign: 'center' }}>Track Leads</h2>
          <div style={{ textAlign: 'center', padding: '60px 0', background: 'var(--surface-container-low)', borderRadius: 12, border: '1px dashed var(--border)' }}>
            <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 24, fontWeight: 700, color: 'var(--slate-400)', letterSpacing: '.05em', textTransform: 'uppercase' }}>Coming Soon</h3>
          </div>
        </div>
      </Sec>
    </div>
  );
};

export default ExecutivePage;
